var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flexbox"},_vm._l((_vm.$props.pages),function(i){return _c('a',{key:("page-" + i),attrs:{"href":((_vm.$route.path) + "?page=" + i)}},[_c('li',{staticClass:"pagination-element"},[_vm._v(" "+_vm._s(i)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }